import { gql } from '@apollo/client';

export const CUSTOMER_FIELDS_FRAGMENT = gql`
  fragment CustomerFields on Customer {
    id
    objectId: id
    createdAt
    updatedAt
    customerPhone
    customerEmail
    customerFirstName
    customerLastName
    channel
    phoneNumber
    customerExternalId
    simplrAccountId
  }
`;
